import { Box, Divider, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import { modelQueryUrl } from '../../api/http';
import { DepositState } from '../../api/models';
import browserHistory from '../../browserHistory';
import { withRouteTitle } from '../../helpers/withRouteTitle';
import { translate } from '../../providers/locale';
import RemoteItems from '../../shared/RemoteItems';

const DepositsOutboundPage: React.FC<{

}> = ({ }) => {
	return <List component="nav">
		<RemoteItems
			endpoint={modelQueryUrl('/deposits/dealer-deposit-group', {
				states: [DepositState.OutboundReady]
			})}
			divider={<Divider />}
			each={(item: any) => ( // TODO: Type
				<ListItem button key={item.id} onClick={() => browserHistory.push(`/deposits/outbound/${item.id}`)}>
					<Box p={1}>
						<ListItemText primary={item.name} secondary={item.address} />
						{item.states.map((stateItem: any) => ( // TODO: Type
							<Typography key={stateItem.state}>{translate(stateItem.state, {
								[DepositState.OutboundReady]: 'Naložit'
							})}: {stateItem.count}x</Typography>
						))}
					</Box>
				</ListItem>
			)}
		/>
	</List>;
}

export default withRouteTitle(DepositsOutboundPage, 'Nakládka uskladněnek');
